<template>
  <section class="maintenance-timeline" role="region" aria-labelledby="maintenance-title">
    <div class="maintenance-timeline__header">
      <div>
        <h2 id="maintenance-title">Próximos mantenimientos</h2>
        <p class="muted">Anticipa revisiones y reduce imprevistos.</p>
      </div>
      <UiButton v-if="showAction" variant="primary" size="sm" @click="$emit('create')">
        + Programar
      </UiButton>
    </div>

    <div v-if="loading" class="maintenance-timeline__list">
      <div v-for="n in 3" :key="`maint-skel-${n}`" class="maintenance-timeline__item">
        <span class="timeline-dot skeleton"></span>
        <div class="timeline-card">
          <div class="skeleton skeleton-line" style="width: 70%"></div>
          <div class="skeleton skeleton-line" style="width: 40%"></div>
          <div class="skeleton skeleton-line" style="width: 60%"></div>
        </div>
      </div>
    </div>

    <div v-else class="maintenance-timeline__list">
      <article
        v-for="item in items"
        :key="item.id"
        class="maintenance-timeline__item"
        :class="`tone-${item.tone}`"
      >
        <span class="timeline-dot" aria-hidden="true"></span>
        <div class="timeline-card">
          <div class="timeline-card__header">
            <div>
              <h3>{{ item.name }}</h3>
              <p class="muted">{{ item.dateLabel }}</p>
            </div>
            <UiBadge :tone="item.tone">{{ item.badge }}</UiBadge>
          </div>
          <div class="timeline-card__meta">
            <span class="timeline-time">{{ item.timeRemaining }}</span>
            <UiButton variant="subtle" size="sm" @click="$emit('open', item.raw)">
              Ver detalle
            </UiButton>
          </div>
        </div>
      </article>

      <div v-if="!items.length" class="empty-card">
        <p>No hay mantenimientos programados.</p>
      </div>
    </div>
  </section>
</template>

<script>
import UiBadge from "../ui/UiBadge.vue";
import UiButton from "../ui/UiButton.vue";

export default {
  name: "MaintenanceTimeline",
  components: { UiBadge, UiButton },
  props: {
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    showAction: { type: Boolean, default: true },
  },
};
</script>

<style scoped>
.maintenance-timeline {
  display: grid;
  gap: 16px;
}

.maintenance-timeline__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}

.maintenance-timeline__header h2 {
  margin: 0 0 6px;
}

.maintenance-timeline__header p {
  margin: 0;
}

.maintenance-timeline__list {
  display: grid;
  gap: 14px;
  position: relative;
  padding-left: 6px;
}

.maintenance-timeline__list::before {
  content: "";
  position: absolute;
  left: 8px;
  top: 6px;
  bottom: 6px;
  width: 2px;
  background: rgba(148, 163, 184, 0.18);
}

.maintenance-timeline__item {
  display: grid;
  grid-template-columns: 18px 1fr;
  gap: 12px;
  align-items: start;
}

.timeline-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(148, 163, 184, 0.4);
  margin-top: 12px;
}

.timeline-card {
  background: var(--color-card);
  border: 1px solid var(--border);
  border-radius: 18px;
  padding: 16px;
  display: grid;
  gap: 12px;
  box-shadow: var(--shadow);
}

.timeline-card__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.timeline-card__header h3 {
  margin: 0;
}

.timeline-card__header p {
  margin: 4px 0 0;
  font-size: 13px;
}

.timeline-card__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.timeline-time {
  font-weight: 600;
  color: var(--muted);
}

.tone-danger .timeline-dot {
  background: var(--color-danger);
}

.tone-warning .timeline-dot {
  background: #fbbf24;
}

.tone-info .timeline-dot {
  background: var(--color-accent);
}

.tone-success .timeline-dot {
  background: var(--color-success);
}
</style>
